// extracted by mini-css-extract-plugin
module.exports = {"root":"wizzard-steps-module_root_OkrCX"};